import {getConsumers} from './consumers';
import {RENDER} from '../symbols';
import {types as metrics} from '@servicenow/ui-metrics';

export default function renderContextConsumers(ctxKey, interactionId, details) {
	const consumers = getConsumers(ctxKey);

	for (const consumer of consumers) {
		consumer[RENDER](interactionId, metrics.UPDATE_CONTEXT, details);
	}
}
